import { FC, useEffect, useState } from 'react';
import { Button } from '@heroui/react';
import NotificationIcon from '~/components/atoms/NotificationIcon';
import { useNotificationCount } from '~/hooks/useNotifications';
import { useLocale } from '~/hooks';
import { ROUTES } from '~/constants/routes.contants';

interface NavbarNotificationComponentProps {
  className?: string;
}

export const NavbarNotificationComponent: FC<NavbarNotificationComponentProps> = ({
  className = '',
}) => {
  const { navigateTo } = useLocale();
  const [isMounted, setIsMounted] = useState(false);
  const [localCount, setLocalCount] = useState<number>(0); // Start with 0 for SSR

  const { data: count = 0 } = useNotificationCount();

  useEffect(() => {
    setIsMounted(true);
    // Only try to access localStorage after component is mounted
    if (typeof window !== 'undefined') {
      try {
        const stored = localStorage.getItem('bitecritic-notification-count');
        setLocalCount(stored ? parseInt(stored, 10) : 0);
      } catch {
        setLocalCount(0);
      }
    }
  }, []);

  useEffect(() => {
    if (typeof count === 'number' && isMounted) {
      setLocalCount(count);
    }
  }, [count, isMounted]);

  const handleClick = () => {
    navigateTo(ROUTES.NOTIFICATIONS);
  };

  // During SSR and initial mount, use 0 to ensure server/client match
  const displayCount = isMounted ? localCount : 0;

  return (
    <Button
      isIconOnly
      variant="light"
      onPress={handleClick}
      className={className}
      aria-label="Notifications"
    >
      <NotificationIcon count={displayCount} />
    </Button>
  );
};

export default NavbarNotificationComponent; 